import PropTypes from 'prop-types'
import ContributorIcon from './ContributorIcon'
import React from 'react'
import { Box, Card, CardContent, Grid, Icon } from '@mui/material'
import { CONTRIBUTOR_TYPES } from '../../constants/CustomerConstants'
import ContextMenu from 'common/components/ContextMenu'

// Ligne d'info préfixée d'une icône.
const InfoLine = ({ icon, children }) => (!children ? null : (
    <Grid size={12} container alignItems='center' spacing={0.5} sx={{ fontSize: '14px' }}>
        <Icon sx={{ fontSize: '1rem', color: '#666' }}>{icon}</Icon>
        <Grid size='grow'>{children}</Grid>
    </Grid>
))

InfoLine.propTypes = {
    icon: PropTypes.string,
    children: PropTypes.node,
}

const ContributorCard = ({
    contributor = {},
    onEdit,
    onEditContact,
    onDelete,
}) => {
    const actions = [
        { label: 'Modifier le lien', icon: 'edit', onClick: onEdit, displayed: !!onEdit },
        { label: 'Modifier le contact', icon: 'contact_page', onClick: onEditContact, displayed: !!onEditContact },
        { label: 'Supprimer le lien', icon: 'delete', onClick: onDelete, displayed: !!onDelete },
    ]

    const roleType = CONTRIBUTOR_TYPES.find(c => c.id === contributor.typeContributor)

    const content = (
        <CardContent sx={{ position: 'relative' }}>
            {roleType?.img && (
                <Box
                    component='img'
                    src={roleType.img}
                    alt=''
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        width: 28,
                        height: 28,
                        borderRadius: '50%',
                        border: '2px solid black',
                        backgroundColor: 'white',
                    }}
                />
            )}
            <Grid container spacing={1} alignItems='center'>
                <Grid size={2}>
                    <ContributorIcon contributor={contributor} hideRole />
                </Grid>
                <Grid size={10} container direction='column' spacing={0.25} sx={{ overflowWrap: 'break-word' }}>
                    <InfoLine icon='person'><span style={{ fontWeight: 'bold' }}>{contributor.name}</span></InfoLine>
                    <InfoLine icon='badge'><span style={{ fontStyle: 'italic' }}>{roleType?.label}</span></InfoLine>
                    <InfoLine icon='mail'>{contributor.email}</InfoLine>
                    <InfoLine icon='phone'>{contributor.telephone}</InfoLine>
                    <InfoLine icon='comment'>{contributor.description}</InfoLine>
                </Grid>
            </Grid>
        </CardContent>
    )

    return (
        <Card>
            {(onEdit || onDelete) ? <ContextMenu actions={actions}>{content}</ContextMenu> : content}
        </Card>
    )
}

ContributorCard.propTypes = {
    contributor: PropTypes.shape({
        name: PropTypes.string,
        typeContributor: PropTypes.string,
        description: PropTypes.string,
        telephone: PropTypes.string,
        email: PropTypes.string,
        login: PropTypes.string,
        updateLogin: PropTypes.string,
        updateDate: PropTypes.number,
    }),
    onEdit: PropTypes.func,
    onEditContact: PropTypes.func,
    onDelete: PropTypes.func,
}

export default ContributorCard
